import React from 'react';
import { Caption, Input } from 'fronton-react';
import { FieldErrorsImpl } from 'react-hook-form';

type TProps = {
  form: {
    value: string;
    onChange: (value: string) => void;
    onFocus?: () => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errors: Partial<FieldErrorsImpl<{ [x: string]: any }>>;
  };
  name: string;
  locale: {
    labels: { [p: string]: string };
  };
  mobile: boolean;
};

export const AdaptiveInput = ({
  form: { value, onChange, onFocus, errors },
  name,
  locale: { labels },
  mobile,
}: TProps) => (
  <Input
    data-testid={`input-${labels[name]}`}
    allowClear
    fullWidth={mobile}
    value={value}
    onChange={e => onChange(e.target.value)}
    onFocus={onFocus}
    label={labels[name]}
    aria-label={labels[name]}
    placeholder={labels[name]}
    error={Boolean(errors[name])}
    caption={<Caption error={Boolean(errors[name])} message={errors[name]?.message} />}
  />
);
